<template>
  <div class="usermid">
    <usermidhea />
    <div class="boxsha">
      <div class="umnav flex_start">
        <div class="logo">
          <img src="~assets/base/logo_sample.png" alt="" />
        </div>
        <div class="hyy">{{ navtxt }}</div>
      </div>
    </div>
    <div class="grview between">
      <div class="grroulink">
        <div class="gruserinfo">
          <div class="cover">
            <img src="~assets/user/gryhreg.png" />
          </div>
          <div class="grname mt20">张三</div>
          <div class="gradr">合肥 | 个人会员</div>
          <div class="zxzxbtn">在线咨询</div>
          <div class="logoutbtn">退出登录</div>
        </div>
        <div
          class="colmulist"
          v-for="(clitem, clindex) in rotlist"
          :key="clindex"
        >
          <div class="colmutit">{{ clitem.name }}</div>
          <div
            class="colmuitem"
            v-for="(item, index) in clitem.list"
            :key="index"
            :class="{clmimact:$route.path == item.path}"
            @click="tojump(item)"
          >
            {{ item.lmimname }}
          </div>
        </div>
      </div>
      <router-view class="grrouter" />
    </div>
    <lv-footer />
  </div>
</template>

<script>
import usermidhea from "./child/usermidhea.vue";
import lvFooter from "../../components/content/lvFooter/lvFooter";
export default {
  components: {
    usermidhea,
    lvFooter,
  },
  data() {
    return {
      rotlist: [
        {
          name: "律师管理",
          list: [
            {
              lmimname: "我的咨询",
              path: "/user/my_advice",
            },
            {
              lmimname: "我的关注",
              path: "/user/my_focus",
            },
            {
              lmimname: "我的点赞",
              path: "/user/my_praise",
            },
          ],
        },
        {
          name: "个人信息管理",
          list: [
            {
              lmimname: "个人资料",
              // path: "/user/my_usercen",
            },
            {
              lmimname: "我的收藏",
              path: "",
            },
            {
              lmimname: "下载记录",
              path: "",
            },
            {
              lmimname: "购买记录",
              path: "/user/my_shop_record",
            },
            {
              lmimname: "消息中心",
              path: "",
            },
            {
              lmimname: "帮助中心",
              path: "/user/my_help",
            },
          ],
        },
      ],
    };
  },
  computed: {
    navtxt() {
      return this.$store.state.user.lognavtxt;
    },
  },
  created() {
    this.$store.commit("user/modifylt", "个人中心");
  },
  methods:{
    tojump(rout){
      this.$router.push({
        path:rout.path
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.usermid {
  background-color: #fff;
  .boxsha {
    box-shadow: -1px 1px 9px 0px rgba(0, 0, 0, 0.09);
  }
  .umnav {
    width: 1200px;
    margin: 0 auto;
    height: 90px;

    .logo {
      margin-right: 44px;
      img {
        width: 145px;
      }
    }
    .hyy {
      font-size: 24px;
      color: #333333;
    }
  }
  .grview {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    align-items: flex-start;
    .grroulink {
      width: 230px;
      box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.11);
      .gruserinfo {
        width: 100%;
        text-align: center;
        padding: 26px 0 30px;
        .cover {
          img {
            width: 104px;
            height: 104px;
            border-radius: 50%;
          }
        }
        .grname {
          font-size: 18px;
          color: #333333;
        }
        .gradr {
          font-size: 14px;
          color: #999999;
        }
        .zxzxbtn {
          width: 160px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          margin: 20px auto 0;
          border-radius: 3px;
          font-size: 14px;
          background: #0057ff;
          color: #ffffff;
          cursor: pointer;
        }
        .logoutbtn {
          width: 160px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          margin: 10px auto 0;
          border: 1px solid #0057ff;
          background-color: #ffffff;
          border-radius: 3px;
          font-size: 14px;
          cursor: pointer;
          color: #0057ff;
        }
      }
      .colmulist {
        width: 100%;
        padding-bottom: 20px;
        .colmutit {
          width: 100%;
          height: 48px;
          padding-left: 35px;
          line-height: 48px;
          background: #f4f4f4;
          font-size: 16px;
          color: #333333;
        }
        .colmuitem {
          width: 100%;
          height: 22px;
          padding-left: 35px;
          line-height: 22px;
          margin-top: 20px;
          font-size: 16px;
          cursor: pointer;
          &.clmimact {
            border-left: 4px solid #0057ff;
            padding-left: 31px;
          }
          &:hover {
            border-left: 4px solid #0057ff;
            padding-left: 31px;
          }
        }
      }
    }
    .grrouter {
      width: 940px;
      min-height: 840px;
    }
  }
}
</style>